import uniqueId from '@/utils/uniqueId';

export const props = {
	/**
	 * Id component.
	 * @type {String, Number}
	 */
	id: {
		type: [String, Number],
		default: null
	},
	/**
	 * Disable the entire component.
	 * @type {Boolean}
	 */
	disabled: {
		type: Boolean,
		default: false
	},
	/**
	 * Sets the name of the element.
	 * @type {String}
	 */
	name: {
		type: String,
		default: null
	},
	/**
	 * Sets the variant of the element.
	 * Represents the global variation of the css
	 * @type {String}
	 */
	variant: {
		type: String,
		default: null
	}
};

// Get an element given an ID
export const getById = id =>
	document.getElementById(/^#/.test(id) ? id.slice(1) : id) || null;

export default {
	props,
	data() {
		return {
			uid: '',
			uname: ''
		};
	},
	created() {
		this.uid = this.id || uniqueId('dms_');
	},
	computed: {
		screenSize() {
			return this.$store.getters.screenSize;
		}
	},
	mounted() {
		if (!this.name) {
			const { tagName } = getById(this.uid) || {};
			this.uname = (this.$options.name || tagName || '').toLowerCase();
		} else {
			this.uname = this.name;
		}
	},
	methods: {
		getUniqueId(prefix) {
			return uniqueId(prefix);
		},
		validatePermission(permisions, redirect) {
			const user = this.$store.getters['oidcStore/oidcUser'];
			const userPermissions = (user && user.SupportPermission) || [];

			let roles = [];

			if (Array.isArray(permisions)) {
				roles = permisions;
			} else {
				roles = [permisions];
			}

			const authorized = roles.every(r => userPermissions.includes(r));

			if (redirect && !authorized) {
				this.$router.push('/access-denied');
			}

			return authorized;
		}
	}
};
